import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormQuestionService } from './../service/form-question-service';
import { ShipmentFormInfo } from './../service/form-field';
import { ShipmentFormService } from './../service/shipment-form-service';
import { ActivityLogger } from '../../../activities/activity-logger';
import { GridDetails } from '../../../sample-tracking/tracking-overview/interfaces/grid';
import { SiteShippingBarcodeDetailsData } from '../service/container-barcode-info';
import { ContainerData, ContainerTransferData } from '../../interfaces/shipment-form-data';
import * as moment from 'moment';

@Component({
    selector: 'create-shipment',
    template: require('./create-shipment.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateShipmentComponent {

    public shipmentFormGroup: FormGroup;
    public formData: ShipmentFormInfo = {};
    public showNotSavedAlert = true;
    public gridDetails: GridDetails = {
        header: this.shipmentFormService.getShipmentTableHeader(),
        data: []
    };
    public isDataLoaded = false;
    private containerData: ContainerData[] = [];
    private containerCreationStartedOn = '';

    constructor(
        private formQuestionService: FormQuestionService,
        private shipmentFormService: ShipmentFormService,
        activityLogger: ActivityLogger,
    ) {
        moment.locale('en');
        this.containerCreationStartedOn = moment().local().format('DD-MMM-YY hh:mm:ss A Z');
        this.loadFormData();
        activityLogger.logActivity('Create a Shipment');
    }

    public onFormSubmit(isSubmited: boolean) {
        this.showNotSavedAlert = false;
    }

    public formValueChangeEvent($event: boolean) {
        this.showNotSavedAlert = $event;
    }

    private loadFormData() {
        let { formValue, barcodes, gridData, transferData, currentFocus } = this.shipmentFormService.getLocalStorage();
        let startedOnDate = '';
        if (formValue) {
            formValue = JSON.parse(formValue);
            this.formData.formValue = formValue;
            startedOnDate = formValue.createdOn;
        }

        if (barcodes) {
            this.formData.barcodes = barcodes.split(',');
        }
        if (gridData) {
            const gridList = JSON.parse(gridData);
            if (gridList && gridList.data && gridList.data.length) {
                gridList.data.forEach((gd: SiteShippingBarcodeDetailsData) => {
                    this.setGridData(gd);
                });
                this.formData.gridData = this.gridDetails;
                this.formData.containerData = this.containerData;
            }
        }
        if (transferData) {
            this.formData.transferData = JSON.parse(transferData);
        }
        if (currentFocus) {
            this.formData.currentFocus = currentFocus.showShipmentDetails;
        }
        this.formData.containerCreationStartedOn = startedOnDate && startedOnDate.length > 0 ? startedOnDate : this.containerCreationStartedOn;
        this.shipmentFormGroup = this.formQuestionService.getShipmentFormGroup(formValue);
        this.isDataLoaded = true;
    }

    private setGridData(data: SiteShippingBarcodeDetailsData) {
        this.gridDetails.data.unshift(data);
        this.gridDetails = { ...this.gridDetails };
        this.containerData.push({
            accessionId: data.accessionId,
            barcode: data.barcodeRaw,
            containerId: data.containerId,
            userEnteredBarcode: data.userEnteredBarcode
        });
    }
}